import { GeneralPopup } from './general_popup_component';
export default GeneralPopup;
